import { useEffect } from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { useBookmark } from '../services/dataHooks';
import { SpeedReadContent } from '../components/SpeedRead';

export const Route = createFileRoute('/_app/read/$id/speed')({
  component: SpeedReadPage,
});

function SpeedReadPage() {
  const { id } = useParams({ from: '/_app/read/$id/speed' });

  // Collapse sidebar for full-screen speed reading
  useEffect(() => {
    document.body.classList.add('read-full-width');
    return () => document.body.classList.remove('read-full-width');
  }, []);
  const { bookmark, isLoading, error } = useBookmark(id);

  if (isLoading) {
    return (
      <div className="p-4">
        <Trans>Loading...</Trans>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger p-4">
        <Trans>Error loading article</Trans>
      </div>
    );
  }

  if (!bookmark) {
    return (
      <div className="p-4">
        <Trans>Article not found</Trans>
      </div>
    );
  }

  return <SpeedReadContent bookmarkId={id} />;
}
